import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../assets/images/logo.png";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = ({ onOpenSidebar }) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY >= 200);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      style={{ backgroundColor: "#fff" }}
      className={`fixed top-0 left-0 right-0 z-50 h-[64px] sm:h-[72px] md:h-[82px] transition-all duration-500 ease-in-out ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 -translate-y-2 pointer-events-none"
      }`}
    >
      <div
        className="relative h-full mx-auto px-4 sm:px-6 flex items-center justify-between"
        style={{ maxWidth: "1320px" }}
      >
        <button
          onClick={onOpenSidebar}
          aria-label={t("nav.openMenu")}
          className="flex flex-col gap-[4px] sm:gap-[5px] group"
        >
          <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-[#223746] group-hover:opacity-70 transition-opacity duration-200" />
          <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-[#223746] group-hover:opacity-70 transition-opacity duration-200" />
          <span className="block w-5 sm:w-6 md:w-7 h-0.5 bg-[#223746] group-hover:opacity-70 transition-opacity duration-200" />
        </button>

        <div className="flex justify-center items-center gap-2 sm:gap-3">
          <img src={logo} alt="" className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20" />
          <Link
            to="/"
            className="text-[#223746] text-sm sm:text-base md:text-xl font-bold uppercase tracking-wider sm:tracking-widest hover:opacity-70 transition-opacity duration-200"
          >
            {t("header.brand")}
          </Link>
        </div>
        <LanguageSwitcher className="text-[#223746]" />
      </div>
    </header>
  );
};

export default Header;
